// To do: Fix responsiveness of table and form
import {
  Heading,
  Container,
  VStack,
  Text,
  Code,
  Button,
  Box,
  FormControl,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Center,
  SimpleGrid,
} from "@chakra-ui/react";
import { Element } from "react-scroll";
import { CopyIcon } from "@chakra-ui/icons";
import Layout from "../../layout/Layout";
import ContentMenu from "../content-menu";
import GeocodeMapComponent, {
  FeatureCollection,
} from "../mapcomponent/generic";
import { ReactElement } from "react";

interface INavItem {
  title: string;
  nav: string;
}
interface PageResult {
  apiResponse: string;
  geoJSON: FeatureCollection;
}

type PageComponentProps = {
  navItemsV1: INavItem[];
  handleCopy: () => void;
  handleSubmit: () => void;
  isLoading: boolean;
  isDisabled: boolean;
  result: PageResult | null;
  formComponent: ReactElement;
  headerTitle: string;
  headerPath: string;
  headerDescription: string;
  documentationComponent?: ReactElement;
};

export default function PageComponent({
  navItemsV1,
  handleCopy,
  handleSubmit,
  isLoading,
  isDisabled,
  result,
  formComponent,
  headerTitle,
  headerPath,
  headerDescription,
  documentationComponent,
}: PageComponentProps) {
  return (
    <Layout
      children={
        <Container maxW={"7xl"} px={{ base: 4, md: 8, lg: 12 }} py={12}>
          <ContentMenu items={navItemsV1} />
          <VStack spacing="10" alignItems="flex-start" w="full">
            {/* api section */}
            <Element name="api" style={{ width: "100%" }}>
              <Heading as="h2">{headerTitle}</Heading>
              <Text as="p" fontSize={"lg"} mt={5} textDecoration={"underline"}>
                {headerPath}
              </Text>
              <Text as="p" fontSize="lg" mt={5}>
                {headerDescription}
              </Text>
            </Element>

            {/* playground */}
            <Element name="playground" style={{ width: "100%" }}>
              <Box w="full">
                <Heading as="h2">Try out the API</Heading>
                <FormControl mt={"20px"} w={"100%"}>
                  <SimpleGrid
                    columns={{ base: 1, md: 2, lg: 3 }}
                    spacing={{ base: 6, md: 12 }}
                    w="full"
                    alignContent={"space-between"}
                  >
                    {formComponent}
                  </SimpleGrid>
                  <Center>
                    <Button
                      isLoading={isLoading}
                      loadingText="Loading"
                      bg="black"
                      color="white"
                      _hover={{
                        bg: "white",
                        color: "black",
                        borderColor: "black",
                      }}
                      onClick={handleSubmit}
                      isDisabled={isDisabled}
                      variant={"outline"}
                      my={"10px"}
                    >
                      Execute
                    </Button>
                  </Center>
                </FormControl>

                <Tabs mt="40px" align="center">
                  <TabList>
                    <Tab>Map</Tab>
                    <Tab>Details</Tab>
                  </TabList>

                  <TabPanels>
                    <TabPanel>
                      {result ? (
                        <GeocodeMapComponent resultsGeoJSON={result.geoJSON} />
                      ) : (
                        <Center>
                          <Text>
                            Send an API request to view the location on the map
                          </Text>
                        </Center>
                      )}
                    </TabPanel>
                    <TabPanel>
                      <Box>
                        <Box position="relative" w="full">
                          <Box overflowX="auto" w="full" borderRadius="md">
                            <Code
                              bg={"black"}
                              color={"white"}
                              whiteSpace="pre"
                              display="block"
                              p={{ base: 4, md: 8, lg: 12 }}
                              width={"100%"}
                              textAlign={"left"}
                            >
                              {result
                                ? result.apiResponse
                                : "Send an API request to see a response here"}
                            </Code>
                          </Box>
                          <Button
                            color={"white"}
                            _hover={{
                              bg: "white",
                              color: "black",
                              borderColor: "black",
                            }}
                            size="sm"
                            position="absolute"
                            top="0"
                            right="0"
                            mt={"15px"}
                            mr={"10px"}
                            onClick={handleCopy}
                            variant={"outline"}
                            leftIcon={<CopyIcon />}
                          >
                            Copy
                          </Button>
                        </Box>
                      </Box>
                    </TabPanel>
                  </TabPanels>
                </Tabs>

                {documentationComponent ? (
                  <Box mt="56px" w="full">
                    <Element name="documentation">
                      {documentationComponent}
                    </Element>
                  </Box>
                ) : null}
              </Box>
            </Element>
          </VStack>
        </Container>
      }
    />
  );
}
